import { Document, Font, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer"
import theme from "css/theme/light"
import moment from "moment"
import { getExaminationNameTranslation } from "pages/learning/pages/admin/pages/exams/pages/details/components/helpers/AttendeeStatus"
import { useTranslation } from "react-i18next"

Font.register({
  family: "area-normal",
  fonts: [
    {
      src: "assets/learning/AreaNormal-Regular.otf"
    },
    {
      src: "assets/learning/AreaNormal-Bold.otf",
      fontWeight: "bold"
    },
    {
      src: "assets/learning/AreaNormal-Light.otf",
      fontWeight: "light"
    }
  ]
})

// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: theme.palette.foreground.inverted,
    display: "flex",
    justifyContent: "space-between"
  },
  section1: {
    margin: 10,
    marginTop: 30,
    padding: 10,
    textAlign: "center",
    justifyContent: "flex-center"
  },
  section2: {
    margin: 10,
    padding: 10,
    textAlign: "center",
    justifyContent: "flex-center"
  },
  section3: {
    margin: 10,
    marginBottom: 20,
    padding: 10,
    textAlign: "center",
    justifyContent: "flex-center"
  },
  title1: {
    fontFamily: "area-normal",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: 28,
    letterSpacing: 4,
    marginBottom: 16,
    marginTop: 16
  },
  title2: {
    fontFamily: "area-normal",
    textTransform: "uppercase",
    fontSize: 16
  },
  title3: {
    fontFamily: "area-normal",
    fontSize: 16
  },
  normal: {
    fontFamily: "area-normal",
    fontSize: 14,
    fontWeight: "light"
  },
  small: {
    fontFamily: "area-normal",
    fontSize: 14,
    fontWeight: "light",
    width: 430,
    marginHorizontal: "auto",
    marginBottom: 16,
    textWrap: "wrap"
  },
  name: {
    fontFamily: "area-normal",
    textTransform: "uppercase",
    fontSize: 28,
    marginTop: 16,
    marginBottom: 16
  },
  signature: {
    marginHorizontal: "auto",
    marginVertical: 0,
    height: "auto",
    width: 250
  },
  logo: {
    marginHorizontal: "auto",
    marginVertical: 20,
    height: 40,
    width: 130
  },
  bar: {
    height: 5,
    width: 92,
    marginVertical: 30,
    marginHorizontal: 230
  }
})

export const CertificateDocument = ({
  userFullName,
  examinationName,
  completedDate,
  examinationCertificate,
  data
}) => {
  const { t } = useTranslation()
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section1}>
          <Text style={styles.title3}>{t("global.ecomobility", "EcoMobility")}</Text>
          <Text style={styles.title1}>
            {t("learning.admin.titles.educational_certificate", "Educational certificate")}
          </Text>
          <Image src="assets/learning/bar.png" style={styles.bar}></Image>
        </View>
        <View style={styles.section2}>
          <Text style={styles.normal}>
            {t("learning.admin.titles.it_is_hereby", "It is hereby certified that")}
          </Text>
          {userFullName ? (
            <Text style={styles.name}>{userFullName}</Text>
          ) : (
            <Text style={styles.name}>{examinationCertificate.userFullName}</Text>
          )}
          <Text style={styles.small}>
            {t("learning.admin.titles.gas_undergone", "Has undergone EcoMbilitys")}{" "}
            <Text style={{ ...styles.small, fontWeight: "bold" }}>
              {getExaminationNameTranslation(examinationName, t)}{" "}
            </Text>
            {t("learning.admin.titles.with_passing_score", "with passing score")}.
          </Text>
          <Text style={styles.small}>
            {t("global.issued", "Issued")}: {moment(completedDate).format("YYYY-MM-DD")}
          </Text>
        </View>
        <View style={styles.section3}>
          <Image src="assets/learning/Emma-signatur.png" style={styles.signature}></Image>
          <Text style={styles.normal}>Emma Carlsson</Text>
          <Image src="assets/eco-mobility-large-primary.png" style={styles.logo}></Image>
        </View>
      </Page>
    </Document>
  )
}
